import styled from 'styled-components';
import FacebookSolid from 'components/icons/facebookSolid';
import InstagramSolid from 'components/icons/instagramSolid';
import WhatsAppSolid from 'components/icons/whatsAppSolid';
import TiktokSolid from 'components/icons/tiktokSolid';
import TelegramSolid from 'components/icons/telegram';
import { IconContainer } from '../../../../Skills/columns/styled';

export const FacebookIcon = styled(FacebookSolid)`
    color: #1877F2;
`;

export const InstagramIcon = styled(InstagramSolid)`
    color: #DD2A7B;
`;

export const WhatsAppIcon = styled(WhatsAppSolid)`
    color: #25D366;
`;

export const TiktokIcon = styled(TiktokSolid)`
    color: #000000;
`;

export const TelegramIcon = styled(TelegramSolid)`
    color: #37BBFE;
`;

export const StyledIconContainer = styled(IconContainer)`
    & > svg {
        width: 1.875rem;
        height: 1.875rem;
    }
`;
